import React, { useState, useEffect } from 'react'
import "./TransactionsPage.css"
import Header from '../../components/Header'
import MenuBar from '../../components/MenuBar'
import LoadingSpinner from "../../components/placeholders/LoadingSpinner"
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import httpClient from '../../components/helpers/httpClient'
import { useNavigate } from 'react-router-dom'
import Label from '../../components/Label'
import { formatDate } from '../../components/helpers/formatDate'
import { NumericFormat } from 'react-number-format'
import SearchIcon from '@mui/icons-material/Search'
import ClearIcon from '@mui/icons-material/Clear'
import DropDownFilter from '../../components/DropDownFilter'
import { useDispatch, useSelector } from 'react-redux'
import { updateFilters, updateTransactionsList, resetStateTransactionsPage } from '../../store/transactionsPage'
import ExportButton from '../../components/UI/ExportButton.jsx'
import { EXPORT_LIMIT, flattenExportRows } from '../../components/helpers/exportUtils'

function TransactionsPage() {
  const [loading, setLoading] = useState(true)
  const [totalPages, setTotalPages] = useState(1)
  const [limit, setLimit] = useState(20)
  const navigate = useNavigate()

  const dispatch = useDispatch()

  const filters = useSelector(state => state.transactionsPage.filtersTransactions)
  const transactions = useSelector(state => state.transactionsPage.transactionsList)

  const fetchTransactions = async () => {
    setLoading(true)

    const data = {
      filters: filters
    }
    const response = await httpClient.post(import.meta.env.VITE_API_URL + `/api/transactions/get?page=${filters.page}&limit=${limit}`, data)
    dispatch(updateTransactionsList(response.data.transactions))
    setTotalPages(response.data.total_pages)
    setLoading(false)
  }

  const prepareExportData = async () => {
    const data = {
      filters: filters
    }

    const response = await httpClient.post(
      import.meta.env.VITE_API_URL + `/api/transactions/get?page=1&limit=${EXPORT_LIMIT}`,
      data
    )

    return flattenExportRows(response.data?.transactions || [])
  }

  useEffect(() => {
    fetchTransactions()
  }, [])

  useEffect(() => {
    fetchTransactions()
  }, [filters, limit])

  const handleOnClickRow = (transactionID) => { navigate(`/transactions/${transactionID}`) }

  const handleSetSortFilter = (sortType) => {
    console.log(sortType)
  }

  const handlePagination = (event) => {
    const element = event.currentTarget

    if (element.classList.contains("grayed-out")) {
      return
    }

    const type = element.dataset.type
    const updatedFilters = { ...filters }

    switch (type) {
      case "previous":
        updatedFilters["page"] = filters.page - 1
        dispatch(updateFilters(updatedFilters))
        break
      case "next":
        updatedFilters["page"] = filters.page + 1
        dispatch(updateFilters(updatedFilters))
        break
    }
  }

  const handleClearSearchBar = () => {
    dispatch(updateFilters({ ...filters, searchWord: "", page: 1 }))
  }

  const handleSearchWord = (e) => {
    dispatch(updateFilters({ ...filters, searchWord: e.target.value, page: 1 }))
  }

  const handleOnClickDropdownItem = (event, value, idList) => {
    dispatch(updateFilters({ ...filters, typeFilter: value, page: 1 }))
  }

  const getTypeColor = (type) => {
    const t = (type || '').toString().toLowerCase()
    if (t === 'aankoop') return 'red'
    if (t === 'verkoop') return 'green'
    if (t === 'oorsprong') return 'gray'
    return 'gray'
  }

  return (
    <div className='template'>
      <Header>
        <div className="header__actions--left">
          <ExportButton
            data={prepareExportData}
            filename="transactions_export"
            formats={['excel']}
            disabled={loading}
          />
        </div>

        <div className="header__filters" id="company__table-btns">
          <div className="search-bar" id="companies__search-bar--table" onClick={handleClearSearchBar}>
            <input placeholder="Search transaction..." value={filters.searchWord} onChange={handleSearchWord} />
            {filters.searchWord == "" ? <SearchIcon /> : <ClearIcon />}
          </div>
          <DropDownFilter
            idList="transactions__dropdownList--type"
            placeholderText="Filter on type"
            listArray={["Aankoop", "Verkoop", "Oorsprong"]}
            onClickItem={handleOnClickDropdownItem}
            filters={filters}
            value={filters.typeFilter}
            filter={"typeFilter"}
            setValue={updateFilters}
          />
        </div>
      </Header>

      <MenuBar />

      <div className="template__body" id="body-transactions">
        <button className="floating__button--bottom-right" id="add--btn" onClick={() => navigate('/transactions/new')} />
          <div className='body__section big' id='all-companies-table'>
            <div className='table'>
              <div className='table__header-9'>
                <div className='table__header--field' onClick={() => handleSetSortFilter("id")}>ID</div>
                <div className='table__header--field' onClick={() => handleSetSortFilter("contract_date")}>Contract date</div>
                <div className='table__header--field' onClick={() => handleSetSortFilter("deed_date")}>Deed date</div>
                <div className='table__header--field' onClick={() => handleSetSortFilter("cadastral_nrs")}>Cadastral nr(s)</div>
                <div className='table__header--field' onClick={() => handleSetSortFilter("project_names")}>Project Name(s)</div>
                <div className='table__header--field' onClick={() => handleSetSortFilter("units")}>Unit(s)</div>
                <div className='table__header--field' onClick={() => handleSetSortFilter("buyer_names")}>Koper(s)</div>
                <div className='table__header--field' onClick={() => handleSetSortFilter("transaction_price")}>€ Price</div>
                <div className='table__header--field' onClick={() => handleSetSortFilter("type")}>Type</div>
              </div>
            <div className='table__rows_container'>

              {
                loading ?
                  <LoadingSpinner /> :
                  transactions.map((transaction, index) => {
                    return (
                      <div
                        className={'table__row-9'}
                        key={index}
                        onClick={() => handleOnClickRow(transaction.id)}
                        data-transaction-id={transaction.id}
                      >
                        <div className='table__row--field'>{transaction.id}</div>
                        <div className='table__row--field'>{transaction.contract_date ? formatDate(transaction.contract_date) : ""}</div>
                        <div className='table__row--field'>{transaction.deed_date ? formatDate(transaction.deed_date) : ""}</div>
                        <div className='table__row--field'>
                          {Array.isArray(transaction.cadastral_nrs) &&
                            <div className='labels-container'>
                              {transaction.cadastral_nrs.map((nr, i) => (
                                <span key={i} className="label-item">{nr}</span>
                              ))}
                            </div>
                          }
                        </div>
                        <div className='table__row--field'>
                          {Array.isArray(transaction.project_names) &&
                            <div className='labels-container'>
                              {transaction.project_names.map((name, i) => (
                                <span key={i} className="label-item">{name}</span>
                              ))}
                            </div>
                          }
                        </div>
                        <div className='table__row--field'>
                          {Array.isArray(transaction.units) &&
                            <div className='labels-container'>
                              {transaction.units.map((unit_name, i) => (
                                <span key={i} className="label-item">{unit_name}</span>
                              ))}
                            </div>
                          }
                        </div>
                        <div className='table__row--field'>
                          {Array.isArray(transaction.buyer_names) &&
                            <div className='labels-container'>
                              {transaction.buyer_names.map((buyerName, i) => (
                                <span key={i} className="label-item">{buyerName}</span>
                              ))}
                            </div>
                          }
                        </div>
                        <div className='table__row--field'>€ <NumericFormat
                          value={transaction.transaction_price}
                          thousandSeparator=" "
                          decimalSeparator="," 
                          decimalScale={2}
                          fixedDecimalScale={true}
                          displayType="text"
                        /></div>
                        <div className='table__row--field'>
                          {transaction.type ? <Label title={transaction.type} labelColor={getTypeColor(transaction.type)} /> : null}
                        </div>
                      </div>
                    )
                  })
              }
            </div>
            <div className="pagination">
              <ArrowBackIosIcon className={`pagination__btn ${filters.page == 1 ? "grayed-out" : ""}`} onClick={handlePagination} data-type="previous" id="prevPage" />
              <ArrowForwardIosIcon className={`pagination__btn ${filters.page == totalPages ? "grayed-out" : ""}`} onClick={handlePagination} data-type="next" id="nextPage" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TransactionsPage


